import Micromodal from 'micromodal';
import { fetchClientIp, setCookie } from './requests/modal_requests';
import Cookies from 'js-cookie';

const CookieName = 'SSESSccssmodalforccssshown';
const ExpiresInDays = 30;
const WaitToShowFor = 100; // 45s

const ipWhitelist = [
  '192.168.10.1',
  '128.84.0.0/16', // 0.0 -> 255.255
  '128.253.0.0/16', // 0.0 -> 255.255
  '132.236.0.0/16', // 0.0 -> 132.236.255.255
  '192.35.82.0/24', // 82.0 -> 82.255
  '192.122.235.0/24', // 235.0 -> 235.255
  '192.122.236.0/24', // 236.0 -> 236.255
  '2620:110:D000::/44'
];

const ModalIdString = 'modal-affiliate-popup';

let lastFocusedElement, modalAlreadyShown;

/**
 * Open modal if it meets specific criteria:
 * - User does not have cookie or it has expired
 * - User has an IP address in the whitelist
 *
 * @returns {boolean}
 */
const tryToggleModal = () => {
  lastFocusedElement = document.activeElement;

  if (!document.getElementById(ModalIdString)) {
    console.warn('Missing modal container id');
    return false;
  }

  setTimeout(() => {
    modalAlreadyShown = Cookies.get(CookieName);
    // let modalAlreadyShown = false;

    if (!modalAlreadyShown) {
      Micromodal.show(ModalIdString, {
        onShow: () => {
          // Cookies.set(CookieName, 'yes', { expires: ExpiresInDays });
        },
        onClose: () => {
          try {
            lastFocusedElement.focus();
          } catch (e) {
            console.warn(e);
          }
        }
      });
    }
  }, WaitToShowFor);
};

if (!modalAlreadyShown) {
  fetchClientIp().then(ip_matches => {
    console.log(ip_matches, 'ip_matches');
    if (ip_matches) {
      // tryToggleModal();
      setCookie().then(hasCookie => {
        // do something
        console.log(hasCookie, 'hasCookie');
        if (!hasCookie) {
          tryToggleModal();
        }
      });
    }
  });
}
